import { useMediaQuery } from 'react-responsive'
import { DESKTOP_BREAKPOINT, MOBILE_BREAKPOINT } from 'utils/responsive'

export const useIsMobile = (breakpoint = MOBILE_BREAKPOINT) => {
  return useMediaQuery({
    query: `(max-width: ${breakpoint}px)`
  })
}

export const useIsDesktop = (breakpoint = DESKTOP_BREAKPOINT) => {
  return useMediaQuery({
    query: `(mim-width: ${breakpoint}px)`
  })
}

// export const useIsTablet = (breakpoint = MOBILE_BREAKPOINT) => {
//   return useMediaQuery({
//     query: `(max-width: ${breakpoint}px)`
//   })
// }
